import { withStyles } from '@material-ui/core';
import {Forms as FormsViewWeb, NewUiWrapper } from '@tuqqi/web';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'recompose';
import { store } from '../../../..';
import { saveMapping } from '../customInputTemplates/customInputTemplateUtils';
import goTo from '../../../actions/goTo';
import { push } from 'react-router-redux';

const styles = theme => ({
    wrap: {

    }
});

const FormsView = (props) => {
	const {globalData, mappings, customInputService, dispatch, params, defaultInputTemplates} = props

	const defaultDataTypes = defaultInputTemplates.map(x => x.dataType)

	const handleNavigateCustomInputToEdit = (mapping) => {
		if(!mapping?.id && defaultDataTypes.includes(mapping?.customDataMapping?.dataTypeFilter)) {
			dispatch(push(`/admin/custominputmappings/create/${mapping?.customDataMapping?.dataTypeFilter}`));
			return
		}
		const param = mapping ? mapping?.id : ""
		console.log("mapping.id",mapping?.id)
		dispatch(push(`/admin/custominputmappings/create/${param}`));
	}

	const getId = () => {
		return params.id
	}

	const handleSaveMapping = (newMappingData) => {
		saveMapping({globalData, customInputService, goTo, dispatch, mappings, newMapData: newMappingData })
	}

    const callbacks = {
		handleNavigateCustomInputToEdit: handleNavigateCustomInputToEdit,
		handleSaveMapping: handleSaveMapping,
		getId: getId,
    }


    return <NewUiWrapper store={store} callbacks={callbacks}>
        <FormsViewWeb />
    </NewUiWrapper>}

const mapStateToProps = (state) => ({
	customInputService: state.services.customInputService,
	globalData: state.globalData,
	defaultInputTemplates: state.globalData.defaultInputTemplates ?? [],
	mappings: state.customInputMapping.currentMapping,
})

const mapDispatchToProps = dispatch => {
    return { dispatch }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
))(FormsView);
